module.exports = __webpack_public_path__ + "i.no1.b55d2db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/i.no1.jpg
// module id = WpI+
// module chunks = 0